<template>
	<modal name="NewBonuses" v-bind:click-to-close="false" :width="400" :adaptive="true">
		<div class="row pad" v-if="load == false">
			<div class="col-12">
				<h4>{{ title }}</h4>
				<hr>
				<div class="form-group">
					<label for="">Monto :</label>
					<money v-model="form.amount" class="form-control"></money> 
					<div v-if="(errors && errors.amount)" class="text-danger">{{ errors.amount[0] }}</div>
				</div>
			</div>
			<div class="col-12 mt-3">
				<div class="row">
					<div class="col-6">
						<button class="btn btn-outline-warning" @click="reset">
							<i class="fas fa-undo-alt"></i>
							Cerrar
						</button>
					</div>
					<div class="col-6 text-right">
						<button class="btn btn-outline-success" @click="save">
							<i class="fas fa-save"></i>
							Guardar
						</button>

					</div>
				</div>
			</div>
		</div>
		<div class="row" v-else>
			<div class="col-md-12">
				<div class="load">Loading...</div>
			</div>
		</div>
	</modal>
</template>
<script>
import { mapActions } from 'vuex';
import request from '../../services/request'
export default {
	name: "new-bonuses",
	data() {
		return {
			title: 'Crear Bonos',
			form: {
				id: '',
				amount: '',
			},
			errors: {},
			load: false,
		}
	},
	created(){
		Event.$on("event-new-bonuses", id => {
			this.title = 'Nuevo Bono';
			if(id){
				this.title = 'Editar Bono';
				this.get_id(id);	
			}
        });
	},
	mounted() {
		let id = this.$route.params.id;
		if (id) {
			this.form.proyect_id = id;
		}
	},
	methods: {
		async save() {
			this.load = true;
			let _endpoint = '';
			if(this.form.id){
				_endpoint = `/bonuses/${this.form.id}`;
				this.form._method = 'PUT';
			}else{
				_endpoint = `/bonuses`;
			}
			try {
				let { data } = await request.post(_endpoint, this.form)
				if (data) {
					this.reset();
					this.successNotification(data.message);
					Event.$emit('event-load-bonuses', '');
				}
			} catch (error) {
				this.load = false;
				this.errors = {};
				if (error.response) {
					this.errors = await this.errorNotification(error);
				}
			}
		},
		async get_id(id) {
			this.form.id = id;
			let _endpoint = `/bonuses/${id}`;
			try {
				let { data } = await request.get(_endpoint)
				if (data) {
					let form = this.form;
					Object.keys(form).forEach(key => {
						this.form[key] = data[key];
					});
					this.form.contact_id = data.contact
					this.form.user_id = data.user
				}
			} catch (error) {
				this.errors = {};
				if (error.response) {
					this.errors = await this.errorNotification(error)
				}
			}
		},
		reset() {
			this.load = false;
			this.errors = {};
			this.form.amount = '';
			this.$modal.hide('NewBonuses');
		},
		...mapActions({
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		})
	}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
<style>
.pad {
	padding: 10px !important;
}
.mx-datepicker {
	width: 100%;
}
</style>
